import { HamburgerIcon } from '@chakra-ui/icons';
import {
  Box,
  Flex,
  IconButton,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import { E_LOGO_TYPES, RepublicLogo } from '@r-client/republic/feature/brand';

interface IMobileProps {
  onOpen: () => void;
}
export const MobileNav = ({ onOpen, ...rest }: IMobileProps) => {
  return (
    <Flex
      p="16px"
      position="fixed"
      top={0}
      w="100%"
      zIndex={2}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      alignItems="center"
      display={{ base: 'flex', md: 'none' }}
      bgColor="white"
      {...rest}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        flexGrow="1"
        position="relative"
      >
        <IconButton
          aria-label="Open side menu"
          icon={<HamburgerIcon />}
          variant="auxiliary"
          onClick={onOpen}
          position="absolute"
          left={0}
        />
        <RepublicLogo type={E_LOGO_TYPES.RLogo} />
        <Text fontSize="24px" fontWeight="bold">
          Republic
        </Text>
      </Box>
    </Flex>
  );
};
